import { IconProps } from './IconsTypes'

export const XCloseGlobal = ({ className }: IconProps) => (
  <svg
    className={`block w-full ${className ?? ''}`}
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      d="M14.1146 16L7.05728 23.0574C6.53595 23.5774 6.53595 24.4227 7.05728 24.9427C7.57862 25.464 8.42128 25.464 8.94262 24.9427L15.9999 17.8854L23.0573 24.9426C23.5786 25.464 24.4213 25.464 24.9426 24.9426C25.464 24.4226 25.464 23.5774 24.9426 23.0574L17.8853 16L24.9426 8.94265C25.464 8.42265 25.4639 7.5774 24.9426 7.0574C24.6826 6.7974 24.3413 6.66669 23.9999 6.66669C23.6586 6.66669 23.3173 6.7974 23.0573 7.0574L15.9999 14.1147L8.94262 7.0574C8.68262 6.7974 8.34128 6.66669 7.99995 6.66669C7.65862 6.66669 7.31728 6.7974 7.05728 7.0574C6.53595 7.5774 6.53595 8.42265 7.05728 8.94265L14.1146 16Z"
      fill="#0A0A0A"
    ></path>
  </svg>
)
